import { Controller } from "@hotwired/stimulus"
import { Modal } from "../utils/modal"

export default class extends Controller {
  static targets = ["sourceCustomer", "sourceProject", "targetCustomer", "targetProject", "projectDetails", "cloneSystemMessages", "cloneExpertMessages", "cloneAiSettings", "cloneAiMasterInstruction", "cloneGptInstances", "gptInstancesContainer", "gptInstancesList", "cloneAiComplianceAnswers", "cloneAiCoordinationMails"]

  connect() {
    this.targetCustomerTarget.disabled = true
    this.targetProjectTarget.disabled = true
    this.sourceProjectLocale = null
  }

  loadProjects(event) {
    const customerId = event.target.value
    const projectSelect = this.sourceProjectTarget
    projectSelect.innerHTML = '<option value="">' + window.I18n.notifications.select_project + '</option>'

    if (customerId) {
      projectSelect.disabled = true

      fetch(`/admin/clone_project/get_projects?customer_id=${customerId}`)
        .then(response => response.json())
        .then(projects => {
          projects.forEach(project => {
            const option = document.createElement('option')
            option.value = project.id
            option.textContent = project.name
            projectSelect.appendChild(option)
          })
          
          projectSelect.disabled = false
        })

      // Preselect the source customer as target customer
      this.targetCustomerTarget.value = customerId
      this.targetCustomerTarget.disabled = false
      
      // Load target projects for the selected customer
      this.updateTargetProjects()
    } else {
      projectSelect.disabled = true
      this.hideProjectDetails()
      
      // Reset target customer when source customer is cleared
      this.targetCustomerTarget.value = ''
      this.targetCustomerTarget.disabled = true
      this.targetProjectTarget.disabled = true
    }
  }

  loadTargetProjects(event) {
    const customerId = event.target.value
    const sourceCustomerId = this.sourceCustomerTarget.value
    
    if (customerId) {
      if (sourceCustomerId && customerId !== sourceCustomerId) {
        this.showWarningModal()
      }
      
      this.updateTargetProjects()
    } else {
      this.targetProjectTarget.disabled = true
    }
  }

  updateTargetProjects() {
    const customerId = this.targetCustomerTarget.value
    const targetProjectSelect = this.targetProjectTarget
    const sourceProjectId = this.sourceProjectTarget.value

    if (!customerId) {
      targetProjectSelect.disabled = true
      return
    }

    targetProjectSelect.innerHTML = '<option value="">' + window.I18n.notifications.select_project + '</option>'
    targetProjectSelect.disabled = true

    fetch(`/admin/clone_project/get_projects?customer_id=${customerId}`)
      .then(response => response.json())
      .then(projects => {

        projects.forEach(project => {
          if (project.id.toString() !== sourceProjectId) {
            const option = document.createElement('option')
            option.value = project.id
            option.textContent = project.name

            if (this.sourceProjectLocale && project.locale !== this.sourceProjectLocale) {
              option.disabled = true
            }

            targetProjectSelect.appendChild(option)
          }
        })

        targetProjectSelect.disabled = false
      })
  }

  loadProjectDetails(event) {
    const customerId = this.sourceCustomerTarget.value
    const projectId = event.target.value
    
    if (projectId) {
      this.targetCustomerTarget.disabled = false

      fetch(`/admin/clone_project/get_project_details?customer_id=${customerId}&project_id=${projectId}`)
        .then(response => {
          return response.json()
        })
        .then(projectData => {
          this.updateCloneOptions(projectData)
          this.sourceProjectLocale = projectData.locale
          this.updateTargetProjects()
        })
    } else {
      this.disableAllCloneOptions()
      this.targetCustomerTarget.disabled = true
      this.targetProjectTarget.disabled = true
      this.sourceProjectLocale = null
    }
  }

  updateCloneOptions(projectData) {
    this.cloneSystemMessagesTarget.disabled = !projectData.system_messages
    this.cloneExpertMessagesTarget.disabled = !projectData.expert_messages
    this.cloneAiSettingsTarget.disabled = !projectData.ai_settings
    this.cloneAiMasterInstructionTarget.disabled = !projectData.ai_master_instruction
    this.cloneGptInstancesTarget.disabled = !projectData.gpt_instances || projectData.gpt_instances.length === 0
    this.cloneAiComplianceAnswersTarget.disabled = !projectData.ai_compliance_answers
    this.cloneAiCoordinationMailsTarget.disabled = !projectData.ai_coordination_mails

    this.updateGptInstanceCheckboxes(projectData.gpt_instances)
  }

  updateGptInstanceCheckboxes(gptInstances) {
    const container = this.gptInstancesContainerTarget
    const list = this.gptInstancesListTarget
    
    if (!gptInstances || gptInstances.length === 0) {
      container.style.display = 'none'
      return
    }

    list.innerHTML = ''
    
    gptInstances.forEach(gptInstance => {
      const div = document.createElement('div')
      div.className = 'form-check'

      const id = `clone_gpt_instance_${gptInstance.id}`
      
      const checkbox = document.createElement('input')
      checkbox.type = 'checkbox'
      checkbox.className = 'form-check-input'
      checkbox.name = 'clone_gpt_instances[]'
      checkbox.value = gptInstance.id
      checkbox.id = id
      
      const label = document.createElement('label')
      label.className = 'form-check-label'
      label.setAttribute("for", id)
      label.textContent = `${gptInstance.name}`
      
      div.appendChild(checkbox)
      div.appendChild(label)
      list.appendChild(div)
    })
    
    container.style.display = 'block'
  }

  disableAllCloneOptions() {
    const checkboxes = [
      this.cloneSystemMessagesTarget,
      this.cloneExpertMessagesTarget,
      this.cloneAiSettingsTarget,
      this.cloneAiMasterInstructionTarget,
      this.cloneGptInstancesTarget,
      this.cloneAiComplianceAnswersTarget,
      this.cloneAiCoordinationMailsTarget
    ]
    
    checkboxes.forEach(checkbox => {
      if (checkbox) {
        checkbox.disabled = true
        checkbox.checked = false
      }
    })
  }

  showWarningModal() {
    Modal.danger({
      title: window.I18n.notifications.different_customer_warning_title,
      message: window.I18n.notifications.different_customer_warning_message,
      confirmText: window.I18n.notifications.different_customer_warning_confirm,
      cancelText: window.I18n.general.cancel,
      onConfirm: () => {},
      onCancel: () => {
        this.targetCustomerTarget.value = "";
        this.targetProjectTarget.value = "";
        this.targetProjectTarget.disabled = true;
      }
    });
  }
} 